import './Field.css';

function Field({label, children, listClassName = '', listLabelClassName, title}) {
    return (
        <div className={"field " + listClassName} title={title ? title : label}>
            <label className={listLabelClassName} >{label}</label>
            {children}
        </div>
        
    )
}

export default Field